module.exports = __webpack_public_path__ + "img/1699318891463-NIB METTY.png.24ff3335.webp";